export default {
  common: {
    loading: "Loading...",
    cancel: "Cancel",
    confirm: "Confirm",
    noMore: "No more data",
    loadMore: "Load more",
    loadingMore: "Loading more...",
    refreshSuccess: "Refresh successful",
    refreshFailed: "Refresh failed",
    landscapeTip:
      "Please rotate your phone to portrait mode for a better experience",
    submit: "Submit",
    all: "All",
    language: "Language",
  },
  tabBar: {
    home: "Home",
    notice: "Notice",
    profile: "Profile",
  },
  notice: {
    title: "Notifications",
    tabs: {
      notification: "Notification",
      reply: "Replies",
      mention: "Mentions",
      like: "Likes",
    },
    replyComment: "{username} replied to your comment",
    replyPost: "{username} replied to your post",
    mentionComment: "{username} mentioned you",
    mentionPost: "{username} mentioned you",
    likeComment: "{username} liked your comment",
    likePost: "{username} liked your post",
    system: "System Notification",
    empty: "No messages yet",
  },
  home: {
    gameName: "Puzzles & Survival",
    unboundRole: "Role Unbound",
    pleaseLogin: "Please log in",
    loginNow: "Log in",
    loginInSuccess: "Login successfully",
    signIn: "Check In",
    hasSigned: "Checked In",
    signInFailedTip: "Checked In failed, please try again later",
    signSuccess: "Checked In successfully",
    signFailed: "Checked In failed",
    goToShop: "Go to Store",
    pullToRefresh: "Pull to refresh",
    releaseToRefresh: "Release to refresh",
    sortByTime: "Latest",
    sortByLastPost: "Commented",
    tags: {
      recommend: "Trending",
      chats: "Chat",
      guide: "Guide",
      activity: "Activity",
      news: "News",
    },
  },
  post: {
    title: "post",
    create: {
      title: "Create Post",
      submit: "Submit",
      titlePlaceholder: "Enter Title",
      contentPlaceholder: "What's on your mind...",
      image: "Image",
      video: "Video",
      mention: "{'@'}",
      selectBoard: "Select Board",
      topicLabel: "Topic",
      imageSizeLimit: "Image size cannot exceed 5MB",
      videoSizeLimit: "Video size cannot exceed 50MB",
      titleEmpty: "Title cannot be empty",
      contentEmpty: "Content cannot be empty",
      submitting: "Submitting...",
      success: "Success",
      failed: "Failed",
      imageUploading: "Uploading image, please wait...",
      imageUploadSuccess: "Image uploaded successfully",
      imageUploadFailed: "Image upload failed",
      videoUploading: "Uploading video, please wait...",
      videoUploadSuccess: "Video uploaded successfully",
      videoUploadFailed: "Video upload failed",
      maxCharsReached: "Maximum character limit reached ({max} characters)",
      invalidFileType: "Unsupported file type",
      fileTooLarge: "File size exceeds limit (max {maxSize})",
    },
  },
  postDetail: {
    writeSomething: "Write something...",
    sending: "Sending...",
    sendSuccess: "Sent successfully",
    sendFailed: "Failed to send",
    loadFailed: "Failed to load",
    noContent: "No content",
    allReplies: "All Replies",
    onlyAuthor: "Author Only",
    earliest: "Published",
    latest: "Latest",
    allComments: "All {num} Replies",
    replyTo: "Reply to",
    author: "Author",
    floor: "Floor",
    reply: "Reply",
    favoriteSuccess: "Favorited successfully",
    cancelFavorite: "Unfavorited",
    viewOriginalPost: "View Original Post",
    commentTooShort: "Comment content cannot be less than 5 characters",
    translate: "Translate",
    translating: "Translating...",
    translateSuccess: "Translated successfully",
    translateFailed: "Translation failed",
    translatedTo: "Translated to",
  },
  operateModal: {
    title: "Operate",
    copyLink: "Copy",
    delete: "Delete",
    shareToGame: "Share to game",
    copySuccess: "Copied successfully",
    confirmDelete: "Are you sure you want to delete this post?",
    deleteSuccess: "Deleted successfully",
    deleteFailed: "Delete failed",
    copyFailed: "Copy failed",
  },
  shareModal: {
    selectChannelTitle: "Please select the channel to share to",
    channelLabel: "Channel",
    channelPlaceholder: "Select channel",
    alliance: "Alliance",
    shareSuccess: "Shared successfully",
    continueBrowse: "Continue browsing",
    goToGame: "Go to game",
    noThreadTip: "Please open a post first",
  },
  profile: {
    title: "Profile",
    editNickname: "Edit",
    communityId: "Community ID",
    followers: "Followers",
    follow: "Follow",
    followSuccess: "Followed successfully",
    unfollowSuccess: "Unfollowed successfully",
    addLikeSuccess: "Liked successfully",
    cancelLikeSuccess: "Unliked successfully",
    likes: "Likes",
    tabs: {
      posts: "My Posts",
      favorites: "My Favorites",
    },
    followed: "Followed",
    noPosts: "No posts yet",
    noFavorites: "No favorites yet",
    shopLabel: "STORE",
  },
  search: {
    btn: "Search",
    hotTitle: "Hot Searches",
    historyTitle: "Search History",
    tabs: {
      post: "Post",
      user: "User",
    },
    empty: "No related content yet",
    filter: {
      title: "Sort by",
      views: "Hottest",
      dateline: "Latest",
    },
    relatedPosts: "Related Posts",
  },
  nicknameModify: {
    placeholder: "Please enter nickname",
    myCoins: "My Points: ",
    getMore: "Get More",
    description:
      "Changing nickname costs 50 points, first change free every month",
    alreadyRenamed:
      "You can only change your nickname once per month, you have already changed it this month",
    sameNickname: "Nickname cannot be the same as the current nickname",
    nicknameTooShort: "Nickname cannot be less than 3 characters",
    coinNotEnough: "Not enough points",
    viewRecord: "View Modification History",
    recordTitle: "Modification History",
    date: "Date",
    changedNickname: "Changed Nickname",
    cost: "Cost",
    success: "Success",
  },
  shop: {
    title: "Store",
    record: "Exchange Record",
    emptyTip: "Store is under construction, stay tuned~",
    bindRole: "Bind Character",
    switchRole: "Switch Character",
    tabs: {
      tasks: "Points Tasks",
      rewards: "Reward Exchange",
    },
    taskInProgress: "In Progress",
    taskCompleted: "Completed",
    goToComplete: "Quest",
    exchange: "Exchange",
    exchanged: "Exchanged",
    exchangeConfirmTitle: "Confirm Exchange?",
    currentCoins: "Current Points",
    costCoins: "Points to Consume",
    receiveRole: "Receive Role",
    exchangeSuccess: "Exchange Success",
    exchangeFailed: "Exchange Failed",
  },
  exchangeRecord: {
    time: "Time",
    content: "Content",
    points: "Points",
    empty: "No exchange records",
  },
  setting: {
    title: "Settings",
    about: "About Us",
    service: "TERMS OF SERVICE",
    privacy: "PRIVACY POLICY",
    logout: "Logout",
    logoutSuccess: "Logged out successfully",
  },
  avatar: {
    title: "Edit Avatar",
  },
  commentModal: {
    title: "Comment",
    placeholder: "Write a comment...",
    replyTo: "Reply to {username}",
  },
  bindRole: {
    title: "Bind Role",
    modifyTitle: "Modify Bound Role",
    server: "Server:",
    role: "Role:",
    serverPlaceholder: "Please select server",
    rolePlaceholder: "Please select role",
    bindSuccess: "Role bound successfully",
    bindFailed: "Role binding failed",
    getServerListFailed: "Failed to get server list",
    getRoleListFailed: "Failed to get role list",
    noRole: "No role",
    recentServers: "Your Server",
    allServers: "All Servers",
  },
  mentionModal: {
    title: "Select User",
    searchPlaceholder: "Search user",
  },
  linkModal: {
    title: "Insert Link",
    viewTitle: "View Link",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    close: "Close",
  },
  time: {
    minutesAgo: "{minutes} minutes ago",
    hoursAgo: "{hours} hours ago",
  },
  maintenance: {
    title: "Under Maintenance",
    message:
      "Sorry, the game forum is currently under maintenance. Please try again later.",
  },
  error: {
    common: "Operation failed, please try again later",
    50002: "Login expired, please login again",
    50301: "You do not have permission to post",
    50302: "Post count limit reached",
    50303: "Content length does not meet the requirements",
    50304: "Content contains sensitive words, please modify and try again",
    50308: "You do not have permission to view this post",
    50309: "Post has been deleted or moved",
    50351: "Topic post is closed, cannot reply",
    50353: "You do not have permission to reply",
    50354: "This board is not allowed to reply",
    50355: "Posting too frequently, please try again later",
    50356: "Post count limit reached per hour",
    50361: "Comment does not exist",
    50500: "You do not have permission to search",
    50501: "Search function is closed",
    50502: "Content contains sensitive words, please modify and try again",
    50006: "This nickname is already in use",
    50007:
      "You can only change your nickname once per month, you have already changed it this month",
    50008: "Not enough coins",
    50505: "Search too frequently, please try again later",
    50703: "Image audit failed",
    50704: "Image content does not conform to specifications",
    50214: "Share failed. You have not joined an @:shareModal.alliance",
  },
};
